// Reduit une photo avant de l'attacher a une ligne de devis.
//
// Une photo de telephone pese 3 a 8 Mo pour 4000 px de large. Sur un document
// imprime, la vignette fait 64 px : tout le reste est du poids inutile dans la
// base, dans le PDF et dans l'email. On reduit donc AVANT l'envoi — le
// navigateur sait le faire, le serveur n'a pas de bibliotheque d'image.
//
// Retourne une data: URI JPEG, ou null si le fichier n'est pas une image.
// coteMax : 900 par defaut (vignette devis) ; les photos de preuve SAV passent
// une valeur plus haute pour garder lisibles numeros de serie et fissures.
const COTE_MAX = 900;
const QUALITE = 0.72;

export function reduirePhoto(fichier, { coteMax = COTE_MAX } = {}) {
  return new Promise((resolve) => {
    if (!fichier || !/^image\//.test(fichier.type)) { resolve(null); return; }
    const url = URL.createObjectURL(fichier);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const ratio = Math.min(1, coteMax / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      const ctx = canvas.getContext('2d');
      // Fond blanc : un PNG transparent vire au noir en JPEG.
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', QUALITE));
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
    img.src = url;
  });
}

// Photo de telephone reduite avant envoi (3-8 Mo → ~300-500 Ko), rendue en
// File pret pour un FormData. 1600 px par defaut : une photo SAV ou de chat
// est une preuve ou un document, pas une vignette. Rend le fichier d'origine
// si ce n'est pas une image ou si le navigateur ne sait pas la lire (HEIC sur
// certains Android) : mieux vaut une photo lourde que pas de photo.
export async function photoAllegee(fichier, { coteMax = 1600 } = {}) {
  const dataUrl = await reduirePhoto(fichier, { coteMax });
  if (!dataUrl) return fichier;
  const bin = atob(dataUrl.split(',')[1]);
  const octets = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) octets[i] = bin.charCodeAt(i);
  const nom = (fichier.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
  return new File([octets], nom, { type: 'image/jpeg' });
}
